// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__3bFEu","check":"styles_check__3fNh3","T":"styles_T___5dzj","F":"styles_F__1HC7A","question":"styles_question__3cngR"};